import { useImageUpload } from 'hooks/blobStorage/useImageUpload';
import { SparkGalleryImagesType } from 'sharedComponents/SparkForm/SparkFormImageGallery';

export const useFormUploadBatchImages = (assetName: string) => {
  const { handleFileUpload } = useImageUpload(assetName);

  const getUrlWithSortOrder = async (
    filesToUpload: SparkGalleryImagesType[]
  ) => {
    const uploadedFilesURl = await Promise.all(
      filesToUpload.map(async (file) => {
        if (file instanceof File) {
          return await handleFileUpload(file);
        }
        return file.preview;
      })
    );

    const urlsWithSortOrder = uploadedFilesURl.map((url, index) => {
      return {
        imageUrl: url,
        sortOrder: index + 1,
      };
    });

    return urlsWithSortOrder;
  };

  return {
    getUrlWithSortOrder,
  };
};
